export default "__VITE_ASSET__042e12f8__"